/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP endpoint registered under a custom domain, with its parent MCP server and project denormalised for display in the dashboard's delete-impact preview.
 */
export type CustomDomainMcpEndpoint = {
  /**
   * The ID of the MCP endpoint
   */
  id: string;
  /**
   * Whether this endpoint is mapped to the custom-domain root
   */
  isDomainRoot: boolean;
  /**
   * The ID of the parent MCP server. Null for meta-MCP-backed endpoints.
   */
  mcpServerId?: string | undefined;
  /**
   * The display name of the parent server. May be empty if the parent has no configured name.
   */
  mcpServerName?: string | undefined;
  /**
   * The url-friendly slug of the parent MCP server. May be empty if the parent has no configured slug or is a meta MCP server.
   */
  mcpServerSlug?: string | undefined;
  /**
   * The ID of the parent meta MCP server. Null for MCP-server-backed endpoints.
   */
  metaMcpServerId?: string | undefined;
  /**
   * The ID of the project the endpoint belongs to
   */
  projectId: string;
  /**
   * The display name of the project the endpoint belongs to
   */
  projectName: string;
  /**
   * The url-friendly slug of the project the endpoint belongs to
   */
  projectSlug: string;
  /**
   * The endpoint slug
   */
  slug: string;
};

/** @internal */
export const CustomDomainMcpEndpoint$inboundSchema: z.ZodMiniType<
  CustomDomainMcpEndpoint,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    is_domain_root: z.boolean(),
    mcp_server_id: z.optional(z.string()),
    mcp_server_name: z.optional(z.string()),
    mcp_server_slug: z.optional(z.string()),
    meta_mcp_server_id: z.optional(z.string()),
    project_id: z.string(),
    project_name: z.string(),
    project_slug: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_domain_root": "isDomainRoot",
      "mcp_server_id": "mcpServerId",
      "mcp_server_name": "mcpServerName",
      "mcp_server_slug": "mcpServerSlug",
      "meta_mcp_server_id": "metaMcpServerId",
      "project_id": "projectId",
      "project_name": "projectName",
      "project_slug": "projectSlug",
    });
  }),
);

export function customDomainMcpEndpointFromJSON(
  jsonString: string,
): SafeParseResult<CustomDomainMcpEndpoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CustomDomainMcpEndpoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CustomDomainMcpEndpoint' from JSON`,
  );
}
